/* LogsViewRenderer.js */

"use strict";
const _ = require("lodash");
const Registrations = require("../../../../../../../RegistrationNamespaces");
const FileName = require("@gluenetworks/steve_utilities").fileName;

class LogsViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("plan-activity-logs-view-gl");
        this._rootElem.component = this._model;
        this._logDisplay = document.createElement("log-display-gl");
        this._rootElem.appendChild(this._logDisplay);
        this._logFile = "";
        this._logFileStarttime = undefined;
        this._onDownloadButtonClick = this._onDownloadButtonClick.bind(this);
        this._actionsRegistered = false;
        this._fileNamer = FileName;
        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._logDisplay = undefined;
            resolve();
        });
        return prom;
    }
    _registerViewActions() {
        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Back",
            name: "back",
            handler: this._onBackButtonClick.bind(this)
        });

        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Download",
            name: "cancel",
            handler: this._onDownloadButtonClick
        });
    }
    _registerListeners() {
        this._model.on("LogAdded", (this._onLogAdded = this._onLogAdded.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeAllListeners("LogAdded");
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return this._model.whenModelIsReady();
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onLogAdded(log) {
        this._appendLog(log);
    }

    _onDownloadButtonClick() {
        if (!_.isEmpty(this._logFile)) {
            this.model.gameEditor.disableViewAction("cancel");
            let fileName = this._fileNamer({
                solution: "OSM",
                general: "ActivityLog",
                specific: this.model.plan.name,
                date: this._logFileStarttime,
                suffix: "txt"
            });
            this.model.io.fileFactory.saveStringAsFile(this._logFile, fileName);
            this.model.gameEditor.enableViewAction("cancel");
        }
    }

    _onBackButtonClick() {
        this.model.gameEditor.setActiveView(Registrations.IOT_OS_PLAN_EDITOR_VIEW_ACTIVITY, [
            {
                value: {
                    fqn: Registrations.IOT_OS_PLAN_EDITOR_SUBVIEW_ACTIVITY_LOGS
                }
            }
        ]);
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    _appendLog(log) {
        if (!this._actionsRegistered) {
            this._registerViewActions();
            this._actionsRegistered = true;
        }
        let logFileLine = [];
        let logEntry = document.createElement("p");
        let timestamp = _.get(log, "time", undefined);
        let fileTimeStamp = timestamp;
        if (!_.isUndefined(timestamp)) {
            fileTimeStamp = Date.create(timestamp).format("{yyyy}-{MM}-{dd}T{HH}:{mm}:{ss}.{fff}");
            timestamp = Date.create(timestamp).format("{HH}:{mm}:{ss}.{fff}");
        } else {
            timestamp = "";
        }
        let time = document.createElement("span");
        time.classList.add("timestamp");
        time.innerHTML = timestamp;
        logFileLine.push(timestamp);
        if (!this._logFileStarttime) {
            this._logFileStarttime = fileTimeStamp;
        }
        let message = document.createElement("span");
        message.classList.add("message");
        let msg = _.get(log, "msg", "");
        message.innerHTML = msg;
        logFileLine.push(msg);
        logEntry.appendChild(time);
        logEntry.appendChild(message);
        this._logDisplay.appendChild(logEntry);
        this._logFile += logFileLine.join(" ") + "\n";
    }
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = LogsViewRenderer;
